"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BIAnalytics = void 0;
var OmnitureHelper_1 = require("./OmnitureHelper");
var BIAnalytics_type_1 = require("./BIAnalytics.type");
var WebBIAnalytics = /** @class */ (function () {
    function WebBIAnalytics() {
    }
    WebBIAnalytics.prototype.landOnDashboard = function (page, refTag) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(page)
            .withSubPageName(BIAnalytics_type_1.PageNames.MAIN)
            .withHitType('1')
            .withReferrer('inside.amazon.com')
            .withRefTag(refTag)
            .build());
    };
    WebBIAnalytics.prototype.clickOnRewardIcon = function (page) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(page)
            .withSubPageName(BIAnalytics_type_1.PageNames.REWARD_STATUS)
            .withHitType('3')
            .withPageAction(BIAnalytics_type_1.PageActions.EXPAND)
            .build());
    };
    WebBIAnalytics.prototype.clickOnLocationEligibility = function (page, refTag) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(page)
            .withSubPageName(BIAnalytics_type_1.PageNames.LOCATION_ELIGIBILITY)
            .withHitType('3')
            .withRefTag(refTag)
            .build());
    };
    WebBIAnalytics.prototype.selectDate = function (page) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(page)
            .withSubPageName(BIAnalytics_type_1.PageNames.MONTHLY_CALENDAR)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.DATE_CHANGE)
            .build());
    };
    WebBIAnalytics.prototype.viewScheduledShiftDetail = function (shiftId, shiftStartTime, shiftEndTime, skills) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SHOW_SCHEDULE)
            .withSubPageName(BIAnalytics_type_1.PageNames.SHIFT_DETAIL)
            .withHitType('3')
            .withPageAction(BIAnalytics_type_1.PageActions.EXPAND)
            .withPageConst(JSON.stringify({
            shiftId: shiftId,
            shiftStartTime: shiftStartTime,
            shiftEndTime: shiftEndTime,
            skills: skills
        }))
            .build());
    };
    WebBIAnalytics.prototype.closeScheduledShiftDetail = function (shiftId) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SHOW_SCHEDULE)
            .withSubPageName(BIAnalytics_type_1.PageNames.SHIFT_DETAIL)
            .withHitType('3')
            .withPageAction(BIAnalytics_type_1.PageActions.CLOSE_SHIFT_DETAIL)
            .withPageConst(shiftId)
            .build());
    };
    WebBIAnalytics.prototype.dropShift = function (shiftId) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SHOW_SCHEDULE)
            .withSubPageName(BIAnalytics_type_1.PageNames.SHIFT_DETAIL)
            .withHitType('3')
            .withPageAction(BIAnalytics_type_1.PageActions.DROP_SHIFT)
            .withPageConst(shiftId)
            .build());
    };
    WebBIAnalytics.prototype.dropShiftFailure = function (shiftId, errorMessage) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SCHEDULES)
            .withSubPageName(BIAnalytics_type_1.PageNames.FIND_SHIFTS)
            .withHitType('3')
            .withPageAction(BIAnalytics_type_1.PageActions.DROP_SHIFT_FAILURE)
            .withPageConst(JSON.stringify({
            shiftId: shiftId,
            errorMessage: errorMessage
        }))
            .build());
    };
    WebBIAnalytics.prototype.navigateToFindShiftPage = function (date, refTag, referrer) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.FIND_SHIFTS)
            .withSubPageName(date)
            .withHitType('1')
            .withReferrer(referrer)
            .withRefTag(refTag)
            .build());
    };
    WebBIAnalytics.prototype.navigateToSwapPage = function (date, refTag) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SWAP)
            .withSubPageName(date)
            .withHitType('1')
            .withRefTag(refTag || '')
            .build());
    };
    WebBIAnalytics.prototype.selectDifferentDate = function (date, pageName) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(pageName)
            .withSubPageName(date)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.DATE_CHANGE)
            .build());
    };
    WebBIAnalytics.prototype.singleStepAddShift = function (date, shiftId, shiftStartTime, shiftEndTime, skills) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.FIND_SHIFTS)
            .withSubPageName(date)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.ADD_SHIFT)
            .withPageConst(JSON.stringify({
            shiftId: shiftId,
            shiftStartTime: shiftStartTime,
            shiftEndTime: shiftEndTime,
            skills: skills
        }))
            .build());
    };
    WebBIAnalytics.prototype.twoStepAddShift = function (date, shiftId, shiftStartTime, shiftEndTime, skills) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.FIND_SHIFTS)
            .withSubPageName(date)
            .withHitType('3')
            .withPageAction(BIAnalytics_type_1.PageActions.ADD_SHIFT)
            .withPageConst(JSON.stringify({
            shiftId: shiftId,
            shiftStartTime: shiftStartTime,
            shiftEndTime: shiftEndTime,
            skills: skills
        }))
            .build());
    };
    WebBIAnalytics.prototype.twoStepShiftAddConfirmation = function (date, shiftId, shiftStartTime, shiftEndTime, skills) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.FIND_SHIFTS)
            .withSubPageName(date)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.CONFIRM_ADD_SHIFT)
            .withPageConst(JSON.stringify({
            shiftId: shiftId,
            shiftStartTime: shiftStartTime,
            shiftEndTime: shiftEndTime,
            skills: skills
        }))
            .build());
    };
    WebBIAnalytics.prototype.popOpenShiftDetail = function (shiftId, shiftStartTime, shiftEndTime, skills) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.FIND_SHIFTS)
            .withSubPageName(BIAnalytics_type_1.PageNames.SHIFT_DETAIL)
            .withHitType('3')
            .withPageAction(BIAnalytics_type_1.PageActions.EXPAND)
            .withPageConst(JSON.stringify({
            shiftId: shiftId,
            shiftStartTime: shiftStartTime,
            shiftEndTime: shiftEndTime,
            skills: skills
        }))
            .build());
    };
    WebBIAnalytics.prototype.closeShiftOpportunityDetail = function (shiftId) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.FIND_SHIFTS)
            .withSubPageName(BIAnalytics_type_1.PageNames.SHIFT_DETAIL)
            .withHitType('3')
            .withPageAction(BIAnalytics_type_1.PageActions.CLOSE_SHIFT_DETAIL)
            .withPageConst(shiftId)
            .build());
    };
    WebBIAnalytics.prototype.singleStepAddShiftViaDetailPage = function (shiftId, shiftStartTime, shiftEndTime, skills) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.FIND_SHIFTS)
            .withSubPageName(BIAnalytics_type_1.PageNames.SHIFT_DETAIL)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.ADD_SHIFT)
            .withPageConst(JSON.stringify({
            shiftId: shiftId,
            shiftStartTime: shiftStartTime,
            shiftEndTime: shiftEndTime,
            skills: skills
        }))
            .build());
    };
    WebBIAnalytics.prototype.twoStepAddShiftViaDetailPage = function (shiftId, shiftStartTime, shiftEndTime, skills) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.FIND_SHIFTS)
            .withSubPageName(BIAnalytics_type_1.PageNames.SHIFT_DETAIL)
            .withHitType('3')
            .withPageAction(BIAnalytics_type_1.PageActions.ADD_SHIFT)
            .withPageConst(JSON.stringify({
            shiftId: shiftId,
            shiftStartTime: shiftStartTime,
            shiftEndTime: shiftEndTime,
            skills: skills
        }))
            .build());
    };
    WebBIAnalytics.prototype.twoStepShiftAddConfirmationViaDetailPage = function (shiftId, shiftStartTime, shiftEndTime, skills) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.FIND_SHIFTS)
            .withSubPageName(BIAnalytics_type_1.PageNames.SHIFT_DETAIL)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.CONFIRM_ADD_SHIFT)
            .withPageConst(JSON.stringify({
            shiftId: shiftId,
            shiftStartTime: shiftStartTime,
            shiftEndTime: shiftEndTime,
            skills: skills
        }))
            .build());
    };
    WebBIAnalytics.prototype.addShiftFailure = function (shiftId, date, errorMessage) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.FIND_SHIFTS)
            .withSubPageName(date)
            .withHitType('3')
            .withPageAction(BIAnalytics_type_1.PageActions.ADD_SHIFT_FAILURE)
            .withPageConst(JSON.stringify({
            shiftId: shiftId,
            errorMessage: errorMessage
        }))
            .build());
    };
    WebBIAnalytics.prototype.openFilterDrawer = function () {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SCHEDULES)
            .withSubPageName(BIAnalytics_type_1.PageNames.FILTERS)
            .withHitType('3')
            .withPageAction(BIAnalytics_type_1.PageActions.VIEW_FILTER)
            .build());
    };
    WebBIAnalytics.prototype.updateSurgePayFilter = function () {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SCHEDULES)
            .withSubPageName(BIAnalytics_type_1.PageNames.FILTERS)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.SURGE_PAY_UPDATE)
            .build());
    };
    WebBIAnalytics.prototype.updateStartTimeFilter = function () {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SCHEDULES)
            .withSubPageName(BIAnalytics_type_1.PageNames.FILTERS)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.START_TIME_UPDATE)
            .build());
    };
    WebBIAnalytics.prototype.updateUnavailabilityFilter = function () {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SCHEDULES)
            .withSubPageName(BIAnalytics_type_1.PageNames.FILTERS)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.UNAVAILABILITY_UPDATE)
            .build());
    };
    WebBIAnalytics.prototype.updateLocationFilter = function () {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SCHEDULES)
            .withSubPageName(BIAnalytics_type_1.PageNames.FILTERS)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.LOCATION_UPDATE)
            .build());
    };
    WebBIAnalytics.prototype.updateJobCategoryFilter = function () {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SCHEDULES)
            .withSubPageName(BIAnalytics_type_1.PageNames.FILTERS)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.JOB_CATEGORY_UPDATE)
            .build());
    };
    WebBIAnalytics.prototype.closeFilterDrawer = function () {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SCHEDULES)
            .withSubPageName(BIAnalytics_type_1.PageNames.FILTERS)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.CLOSE_FILTER_DRAWER)
            .build());
    };
    WebBIAnalytics.prototype.resetFilters = function () {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SCHEDULES)
            .withSubPageName(BIAnalytics_type_1.PageNames.FILTERS)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.RESET_FILTERS)
            .build());
    };
    WebBIAnalytics.prototype.updateFilterOnFindShiftsPage = function () {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SCHEDULES)
            .withSubPageName(BIAnalytics_type_1.PageNames.FILTERS)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.UPDATE_FILTERS)
            .build());
    };
    WebBIAnalytics.prototype.noPenaltyDropShiftFromFindShiftPage = function (shiftId, shiftStartTime, shiftEndTime, skills, opportunityId) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SCHEDULES)
            .withSubPageName(BIAnalytics_type_1.PageNames.FIND_SHIFTS)
            .withHitType('3')
            .withPageAction(BIAnalytics_type_1.PageActions.DROP_SHIFT)
            .withPageConst(JSON.stringify({
            shiftId: shiftId,
            shiftStartTime: shiftStartTime,
            shiftEndTime: shiftEndTime,
            skills: skills,
            opportunityId: opportunityId
        }))
            .build());
    };
    WebBIAnalytics.prototype.noPenaltyShiftDropConfirmation = function (shiftId, shiftStartTime, shiftEndTime, skills, opportunityId) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SCHEDULES)
            .withSubPageName(BIAnalytics_type_1.PageNames.FIND_SHIFTS)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.CONFIRM_DROP_SHIFT)
            .withPageConst(JSON.stringify({
            shiftId: shiftId,
            shiftStartTime: shiftStartTime,
            shiftEndTime: shiftEndTime,
            skills: skills,
            opportunityId: opportunityId
        }))
            .build());
    };
    WebBIAnalytics.prototype.acceptInstantSwap = function (swapFromDate, swapRequestId, employeeId, siteId) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SWAP)
            .withSubPageName(swapFromDate)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.INSTANT_SWAP)
            .withPageConst(JSON.stringify({
            swapRequestId: swapRequestId,
            employeeId: employeeId,
            siteId: siteId
        }))
            .build());
    };
    WebBIAnalytics.prototype.instantSwapSuccess = function (swapFromDate, swapRequestId, employeeId, siteId) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SWAP)
            .withSubPageName(swapFromDate)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.INSTANT_SWAP_SUCCESS)
            .withPageConst(JSON.stringify({
            swapRequestId: swapRequestId,
            employeeId: employeeId,
            siteId: siteId
        }))
            .build());
    };
    WebBIAnalytics.prototype.instantSwapFailure = function (swapFromDate, swapRequestId, employeeId, siteId) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SWAP)
            .withSubPageName(swapFromDate)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.INSTANT_SWAP_FAILURE)
            .withPageConst(JSON.stringify({
            swapRequestId: swapRequestId,
            employeeId: employeeId,
            siteId: siteId
        }))
            .build());
    };
    WebBIAnalytics.prototype.createSwapRequest = function (swapFromDate, selectedSwapRequestDays, employeeId, siteId) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SWAP)
            .withSubPageName(swapFromDate)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.SWAP_REQUEST)
            .withPageConst(JSON.stringify({
            selectedSwapRequestDays: selectedSwapRequestDays,
            employeeId: employeeId,
            siteId: siteId
        }))
            .build());
    };
    WebBIAnalytics.prototype.swapRequestSuccess = function (swapFromDate, selectedSwapRequestDays, employeeId, siteId) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SWAP)
            .withSubPageName(swapFromDate)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.SWAP_REQUEST_SUCCESS)
            .withPageConst(JSON.stringify({
            selectedSwapRequestDays: selectedSwapRequestDays,
            employeeId: employeeId,
            siteId: siteId
        }))
            .build());
    };
    WebBIAnalytics.prototype.swapRequestFailure = function (swapFromDate, selectedSwapRequestDays, employeeId, siteId) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SWAP)
            .withSubPageName(swapFromDate)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.SWAP_REQUEST_FAILURE)
            .withPageConst(JSON.stringify({
            selectedSwapRequestDays: selectedSwapRequestDays,
            employeeId: employeeId,
            siteId: siteId
        }))
            .build());
    };
    WebBIAnalytics.prototype.cancelSwap = function (swapIdsToCancel, employeeId, siteId) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SWAP)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.CANCEL_SWAP)
            .withPageConst(JSON.stringify({
            swapIdsToCancel: swapIdsToCancel,
            employeeId: employeeId,
            siteId: siteId
        }))
            .build());
    };
    WebBIAnalytics.prototype.cancelSwapSuccess = function (swapIdsToCancel, employeeId, siteId) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SWAP)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.CANCEL_SWAP_SUCCESS)
            .withPageConst(JSON.stringify({
            swapIdsToCancel: swapIdsToCancel,
            employeeId: employeeId,
            siteId: siteId
        }))
            .build());
    };
    WebBIAnalytics.prototype.cancelSwapFailure = function (swapIdsToCancel, employeeId, siteId) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.SWAP)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.CANCEL_SWAP_FAILURE)
            .withPageConst(JSON.stringify({
            swapIdsToCancel: swapIdsToCancel,
            employeeId: employeeId,
            siteId: siteId
        }))
            .build());
    };
    WebBIAnalytics.prototype.clickOnDayOneWidget = function () {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.DASHBOARD)
            .withSubPageName(BIAnalytics_type_1.PageNames.DAY_ONE)
            .withHitType('3')
            .withPageAction(BIAnalytics_type_1.PageActions.WIDGET_CLICKED)
            .build());
    };
    WebBIAnalytics.prototype.errorInDayOneWidget = function () {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(BIAnalytics_type_1.PageNames.DASHBOARD)
            .withSubPageName(BIAnalytics_type_1.PageNames.DAY_ONE)
            .withHitType('3')
            .withPageAction(BIAnalytics_type_1.PageActions.WIDGET_ERROR)
            .build());
    };
    WebBIAnalytics.prototype.toggleCalendarView = function (page, calendarType) {
        var pageAction = calendarType === BIAnalytics_type_1.PageNames.WEEKLY_CALENDAR
            ? BIAnalytics_type_1.PageActions.TOGGLE_TO_WEEKLY_CALENDAR
            : BIAnalytics_type_1.PageActions.TOGGLE_TO_MONTHLY_CALENDAR;
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(page)
            .withSubPageName(calendarType)
            .withHitType('3')
            .withPageAction(pageAction)
            .build());
    };
    WebBIAnalytics.prototype.payBreakdownClicked = function (page) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(page)
            .withSubPageName(BIAnalytics_type_1.PageNames.SHIFT_DETAIL)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.PAY_BREAKDOWN_CLICKED)
            .build());
    };
    WebBIAnalytics.prototype.clickOnPaidHoursDisclaimer = function (page) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(page)
            .withSubPageName(BIAnalytics_type_1.PageNames.SHIFT_DETAIL)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.PAID_HOURS_CLICKED)
            .build());
    };
    WebBIAnalytics.prototype.clickOnWageStatementDisclaimer = function (page) {
        OmnitureHelper_1.OmnitureHelper.setOmniturePageInfo(new OmnitureHelper_1.AdobeOmnitureBuilder(page)
            .withSubPageName(BIAnalytics_type_1.PageNames.SHIFT_DETAIL)
            .withHitType('4')
            .withPageAction(BIAnalytics_type_1.PageActions.WAGE_STATEMENT_CLICKED)
            .build());
    };
    return WebBIAnalytics;
}());
exports.BIAnalytics = new WebBIAnalytics();
